"use client";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, CircularProgress, type ButtonProps } from "@mui/material";
import { SystemStyleObject, Theme } from "@mui/system";
import { useTranslations } from "next-intl";
import { type ReactNode } from "react";

interface OnboardingSubmitButtonProps extends Omit<ButtonProps, "type"> {
  formId?: string;
  children: ReactNode;
  sxBox?: SystemStyleObject<Theme>;
}

/**
 * Shared submit button for onboarding/auth step footers. Always enabled — forms
 * validate on submit and surface zod errors inline rather than gating the button.
 */
export const OnboardingSubmitButton = ({
  formId,
  children,
  sxBox = {},
  loading = false,
  ...buttonProps
}: OnboardingSubmitButtonProps) => {
  const t = useTranslations("common");
  return (
    <Box
      sx={(theme) => ({
        paddingX: theme.spacing(6),
        ...sxBox,
      })}
    >
      <Button
        form={formId}
        type="submit"
        variant="contained"
        size="medium"
        endIcon={
          loading ? <CircularProgress size={20} /> : <ArrowForwardIcon />
        }
        sx={{ width: { xs: "100%", md: "auto" } }}
        disabled={Boolean(loading)}
        loadingPosition="end"
        {...buttonProps}
      >
        {loading ? t("loading") : children}
      </Button>
    </Box>
  );
};
